module.exports = __webpack_public_path__ + "media/152.6b3da75f.mp3";